import { Box, Paper } from "@mui/material";
import PageHeader from "components/AppBar/PageHeader";
import { BasePathProvider } from "components/Providers";
import { Route, Routes } from "react-router-dom";
import IndicatorList from "./IndicatorList";
import { getAdminStandards } from "store/lookup";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import AdminEvaluationTabs, { tabConfig } from "./Tabs";
import EvaluationListIndex from "./Evaluation";
import { useTranslation } from "react-i18next";
import RedirectToFirstPermitted from "components/RedirectToPermittedTab";
import NotFound from "components/NotFound";
import Protected from "components/Protected";

export default function AdminEvaluation() {
  const basePath = '/admin-evaluation'
  const adminStandards = useSelector(state => state.lookup.adminStandards)
  const dispatch = useDispatch()
  const { t } = useTranslation();

  useEffect(() => {
    adminStandards || dispatch(getAdminStandards())
  }, [Boolean(adminStandards), dispatch]);

  return (
    <BasePathProvider value={`${basePath}/`}>
    <Box sx={{ mb: 2}}>
        <PageHeader title={t('Admin Evaluation')} />
    </Box>
    <Paper sx={{width: '100%', p: 1, mb: 1}}>
        <AdminEvaluationTabs />
    </Paper>
    <Box sx={{width: '100%', minHeight: '500px'}}>
        <Routes>
            <Route path="/">
                <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
                <Route path="indicator-list/*" element={<Protected permission="evaluation.admin"><IndicatorList adminStandards={adminStandards} /></Protected>} />
                <Route path="evaluation/*" element={<Protected permission="evaluation.admin"><EvaluationListIndex adminStandards={adminStandards} /></Protected>} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    </Box>

</BasePathProvider>
  )
}
